import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SpinnerModule } from './spinner/spinner.module';
import { SelectModule } from './form/select/select.module';
import { ButtonModule } from './form/button/button.module';
import { HeaderComponent } from './header/header.component';
import { LoaderComponent } from './loader/loader.component';
import { TagfieldModule } from './form/tagfield/tagfield.module';
import { TextareaModule } from './form/textarea/textarea.module';
import { TextfieldComponent } from './form/textfield/textfield.component';
import { ColorPickerModule } from './form/color-picker/color-picker.module';
import { MultiSelectModule } from './form/multi-select/multi-select.module';
import { RichtextareaComponent } from './form/richtextarea/richtextarea.component';
import { LottiePlayerComponent } from './lottie-player/lottie-player.component';
import { CopyToClipboardModule } from './copy-to-clipboard/copy-to-clipboard.module';
import { ListItemPickerModule } from './form/list-item-picker/list-item-picker.module';
import { TooltipModule } from './tooltip/tooltip.module';
import { InteractiveLinkContentModule } from './interactive-link-content/interactive-link-content.module';
import { RadioButtonModule } from './radio-btn/radio-btn.module';
import { SwitchModule } from './form/switch/switch.module';
import { FilePickerComponent } from './form/file-picker/file-picker.component';
import { InteractiveVcwPickerModule } from './form/interactive-vcw-picker/interactive-vcw-picker.module';
import { LottieComponent } from 'ngx-lottie';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [LottiePlayerComponent],
  imports: [
    FormsModule,
    CommonModule,
    SelectModule,
    ButtonModule,
    LottieComponent,
    SpinnerModule,
    TextareaModule,
    TagfieldModule,
    TextfieldComponent,
    MultiSelectModule,
    ColorPickerModule,
    RichtextareaComponent,
    ListItemPickerModule,
    CopyToClipboardModule,
    TooltipModule,
    InteractiveLinkContentModule,
    RadioButtonModule,
    SwitchModule,
    FilePickerComponent,
    InteractiveVcwPickerModule,
    MatTooltipModule,
    HeaderComponent,
    LoaderComponent,
  ],
  exports: [
    HeaderComponent,
    LoaderComponent,
    LottiePlayerComponent,
    RadioButtonModule,
    ButtonModule,
    SwitchModule,
    FilePickerComponent,
    InteractiveVcwPickerModule,
    MatTooltipModule,
  ],
})
export class SharedModule {}
